import { css } from 'styled-components'
import { mq } from './config'

const rem = {
  baseMobile: 15,
  base: 18,
  get: (value:number, factor = null) => `${value / (factor ?? rem.baseMobile)}rem`
}

export const vwFont = (size: number, mobile: boolean = true) => rem.get(size, rem[mobile ? 'baseMobile' : 'base'])

// Checkbox
export const font16_20 = ({ weight = 400 }:TypeFont) => css`
  font-size: 16px;
  font-weight: ${weight};
  line-height: 20px;
`
// INPUTS
export const getInputLabelText = () => {
  return css`
    font-size: 15px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -.3px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(15, rem.base)};
      letter-spacing: -.36px;
    }
  `
}

export const getInputHasContentLabelText = () => {
  return css`
    font-size: 12px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: -.3px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(12, rem.base)};
      line-height: ${rem.get(10, rem.base)};
      letter-spacing: -.36px;
    }
  `
}

export const getP18InputHasContentLabel = (weight: 400 = 400) => css`
  font-size: 12px;
  font-weight: ${weight};
  line-height: normal;
  letter-spacing: -.3px;
`
export const getP18InputLabel = (weight: 400 = 400) => css`
  font-size: 18px;
  font-weight: ${weight};
  line-height: normal;
  letter-spacing: -.3px;
`


// TOASTS & ERROR PAGES
export const font12_normal = ({ weight = 400 }:TypeFont) => css`
  font-size: 12px;
  font-weight: ${weight};
  line-height: normal;
`

export const font40_normal = ({ weight = 300 }:TypeFont) => css`
  font-size: 40px;
  font-weight: ${weight};
  line-height: normal;
  letter-spacing: -.8px;
`

export const font30_normal = ({ mobile = false, weight = 400 }:TypeFont) => css`
  font-size: 30px;
  font-weight: ${weight};
  line-height: normal;
  letter-spacing: ${mobile ? .3 : .6}px;
`
// END TOAST & ERROR PAGES

type TypeFont = {
  mobile?: boolean
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900
}
// PROJECT


export const font18 = ({ weight = 400 }:TypeFont) => css`
  font-size: 18px;
  font-weight: ${weight};
  line-height: 120%;
  letter-spacing: 0px;
`

export const getP90 = () => {
  return css`
    font-size: ${rem.get(44, rem.baseMobile)};
    font-weight: 200;
    line-height:${rem.get(48, rem.baseMobile)};
    letter-spacing: -.1px;

    ${mq.greaterThan('tablet')} {
      font-weight: 100;
      font-size: ${rem.get(90, rem.base)};
      line-height: ${rem.get(94, rem.base)};
    }
  `
}

export const getP50 = () => {
  return css`
    font-size: ${rem.get(30, rem.baseMobile)};
    font-weight: 300;
    line-height:${rem.get(36, rem.baseMobile)};
    letter-spacing: -.1px;

    ${mq.greaterThan('tablet')} {
      font-weight: 200;
      font-size: ${rem.get(50, rem.base)};
      line-height: ${rem.get(54, rem.base)};
      letter-spacing: -.06px;
    }
  `
}

export const getP24 = () => {
  return css`
    font-size: ${rem.get(20, rem.baseMobile)};
    font-weight: 300;
    line-height:${rem.get(26, rem.baseMobile)};
    letter-spacing: -.1px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(24, rem.base)};
      line-height: ${rem.get(30, rem.base)};
      letter-spacing: .27px;
    }
  `
}

export const getP24_2 = () => {
  return css`
    font-size: ${rem.get(24, rem.baseMobile)};
    font-weight: 300;
    line-height:${rem.get(26, rem.baseMobile)};
    letter-spacing: -.1px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(24, rem.base)};
      line-height: ${rem.get(30, rem.base)};
    }
  `
}

export const getP24_3 = () => {
  return css`
    font-size: ${rem.get(20, rem.baseMobile)};
    font-weight: 300;
    line-height:${rem.get(26, rem.baseMobile)};
    letter-spacing: -.1px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(24, rem.base)};
      line-height: ${rem.get(30, rem.base)};
    }
  `
}

export const getP20_1 = () => {
  return css`
    font-size: ${rem.get(18, rem.baseMobile)};
    font-weight: 500;
    line-height:${rem.get(15, rem.baseMobile)};
    letter-spacing: -0.36px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(26, rem.base)};
      letter-spacing: -0.5px;
    }
  `
}

export const getP20 = () => {
  return css`
    font-size: ${rem.get(20, rem.baseMobile)};
    font-weight: 500;
    line-height:${rem.get(24, rem.baseMobile)};
    letter-spacing: .5px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(20, rem.base)};
      line-height: ${rem.get(24, rem.base)};
      letter-spacing: .5px;
    }
  `
}

export const getP18 = () => {
  return css`
    font-size: ${rem.get(16, rem.baseMobile)};
    font-weight: 500;
    line-height:${rem.get(24, rem.baseMobile)};
    letter-spacing: .15px;

    ${mq.greaterThan('tablet')} {
      font-weight: 300;
      font-size: ${rem.get(18, rem.base)};
      line-height: ${rem.get(26, rem.base)};
      letter-spacing: -.1px;
    }
  `
}

export const getP17 = () => {
  return css`
    font-size: ${rem.get(16, rem.baseMobile)};
    font-weight: 500;
    line-height:${rem.get(22, rem.baseMobile)};
    letter-spacing: .12px;

    ${mq.greaterThan('tablet')} {
      font-weight: 300;
      font-size: ${rem.get(17, rem.base)};
      line-height: ${rem.get(23, rem.base)};
      letter-spacing: -.12px;
    }
  `
}

export const getP12 = () => {
  return css`
    font-size: ${rem.get(10, rem.baseMobile)};
    font-weight: 500;
    line-height:${rem.get(12, rem.baseMobile)};
    letter-spacing: 0.3px;

    ${mq.greaterThan('tablet')} {
      font-size: ${rem.get(12, rem.base)};
      line-height: ${rem.get(15, rem.base)};
    }
  `
}
